import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { nextStep, ifloorplanStateAdd, initScale } from '../redux/actions/actions';
import { changeImageKey, changeLevel } from '../redux/actions/actions';
import Cam from './Cam';
import Marker from './Marker';
import { Rnd } from 'react-rnd'

const landscapeScaleLayout = (props) => {
    const ifloorplanObj = props.ifloorplanNowState;
    let screenWidth = 88.889 * window.innerHeight / 100;
    let screenHeight = 50 * window.innerHeight / 100;
    const [width, height] = ["88.889vh", "50vh"];
    const [cams, setCams] = useState([]); //array position active cams
    const [videoMarker, setVideoMarker] = useState([]);
    const [doneMarkers, setDoneMarkers] = useState([]);
    const imagesArray = ifloorplanObj.level[props.levelNowId].images;
    const [tabs, setTabs] = useState([]);
    const [mediaTabs, setMediaTabs] = useState([]);
    const [activeButtonTabLevel, setActiveButtonTabLevel] = useState(false);
    const [markerScale, setMarkerScale] = useState(imagesArray.length > 0 ? imagesArray[0].mobile_cam_width : 6);

    const planRef = useRef();

    const [planLevel, setPlanLevel] = useState({
        img: props.plans[props.levelNowId],
        img_width: ifloorplanObj.level[props.levelNowId].landscape_plan_width,
        position_x: ifloorplanObj.level[props.levelNowId].landscape_plan_pos_x,
        position_y: ifloorplanObj.level[props.levelNowId].landscape_plan_pos_y
    })
    const handleScale = (event) => {
        //change size block images
        if (event.target.className === 'scale-floor') {
            setPlanLevel({
                ...planLevel,
                img_width: event.target.value
            });
            planRef.current.updateSize({
                width: event.target.value + '%',
            })
            let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
            newState.level[props.levelNowId].landscape_plan_width = planLevel.img_width;
            newState.level[props.levelNowId].custom_landscape = true;
            props.ifloorplanStateAdd(newState);
        }
    };

    const dragHandleImage = (event, data) => {
        event.preventDefault();
        const childBlock = document.getElementsByClassName(event.target.className)[0];

        const parrentBlock = document.getElementsByClassName("dnd-wrapper")[0];
        let childX = childBlock.getBoundingClientRect().left;
        let childY = childBlock.getBoundingClientRect().top;
        const { top, left, width, height } = parrentBlock.getBoundingClientRect();

        let x = (childX - left) / width * 100; // get position at parsent
        let y = (childY - top) / height * 100;
        setPlanLevel({
            ...planLevel,
            position_x: x,
            position_y: y
        });

        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        newState.level[props.levelNowId].landscape_plan_pos_x = x;
        newState.level[props.levelNowId].landscape_plan_pos_y = y;
        newState.level[props.levelNowId].custom_landscape = true;
        props.ifloorplanStateAdd(newState);
    };

    useEffect(() => {
        markerInit();
        tabsInit(); //init tabs position

        otherMarkerInit();// otherMarkerInit();

        //init colors
        if (props.setShowTools)
            props.setShowTools(true);

        const handleResizeScreen = () => {
            const w = 88.889 * window.innerHeight / 100;
            const h = 50 * window.innerHeight / 100;
            planRef && planRef.current.updatePosition({
                x: planRef.current.draggable.state.x * w / screenWidth,
                y: planRef.current.draggable.state.y * h / screenHeight,
            })
            screenWidth = w;
            screenHeight = h;
            markerInit();
        }

        window.addEventListener('resize', handleResizeScreen);
        return () => window.removeEventListener('resize', handleResizeScreen);
    }, []);

    const markerInit = () => {
        setCams([]);
        for (let i = 0; i < imagesArray.length; i++) {
            if (imagesArray[i]?.cam_pos_x !== 0 && props.image_key !== i) {
                //init active cams
                if (imagesArray[i].button) {
                    setCams(state => [...state, <button className={imagesArray[i].button_class}
                        style={{
                            position: "absolute",
                            top: imagesArray[i].cam_pos_y + "%",
                            left: imagesArray[i].cam_pos_x + "%",
                            background: imagesArray[i].button_bg,
                            color: imagesArray[i].button_color_text,
                            transform: `scale(${imagesArray[i].button_scale})`,
                            fontSize: imagesArray[i].button_font_size / 2 + "vh",
                            width: `${imagesArray[i].button_width * screenHeight / 100}px`,
                            height: `${imagesArray[i].button_height * screenHeight / 100}px`,
                            borderRadius: imagesArray[i].button_radius + "rem",
                            fontWeight: imagesArray[i].button_font_weigh,
                            fontStyle: imagesArray[i].button_font_style,
                            fontFamily: imagesArray[i].button_font_family,
                        }}
                    >{imagesArray[i].button_label}</button>]);
                } else {
                    setCams(state => [
                        ...state,
                        <Cam
                            index={i}
                            value={imagesArray[i]}
                            layout="landscape"
                            viewHeight={screenHeight}
                            img={ifloorplanObj.marker_image}
                            img_hover={ifloorplanObj.marker_image_hover}
                            width={ifloorplanObj.mobile_marker_width}
                        />]);
                }
            }
        }
    }

    const otherMarkerInit = () => {
        const resultArr = []; //init markers 360
        for (let i = 0; i < ifloorplanObj.level[props.levelNowId].panelum.length; i++) {
            if (ifloorplanObj.level[props.levelNowId].panelum[i].pos_x != 0) {
                resultArr.push(
                    <Marker index={i}
                        key={i}
                        value={ifloorplanObj.level[props.levelNowId].panelum[i]}
                        viewHeight={screenHeight}
                        img={ifloorplanObj.marker_image}
                        img_hover={ifloorplanObj.marker_image_hover}
                        width={ifloorplanObj.mobile_marker_width} />)
            }
        }
        setDoneMarkers(resultArr);

        setVideoMarker([]);
        for (let i = 0; i < ifloorplanObj.level[props.levelNowId].video_marker.length; i++) {
            setVideoMarker(state => [...state, <Marker key={i} index={i}
                value={ifloorplanObj.level[props.levelNowId].video_marker[i]}
                viewHeight={screenHeight} />])
        }
    }

    useEffect(() => {
        //set position frontend blocks
        markerInit();
        tabsInit(); //init tabs position

        // otherMarkerInit();
        otherMarkerInit();
        //init colors
        if (props.setShowTools)
            props.setShowTools(true);
    }, [props.image_key, props.ifloorplanNowState, props.levelNowId]);

    useEffect(() => {
        markerInit();
        tabsInit();
        otherMarkerInit();
        setPlanLevel({
            img: props.plans[props.levelNowId],
            img_width: ifloorplanObj.level[props.levelNowId].landscape_plan_width,
            position_x: ifloorplanObj.level[props.levelNowId].landscape_plan_pos_x,
            position_y: ifloorplanObj.level[props.levelNowId].landscape_plan_pos_y
        });
        planRef.current.updatePosition({
            x: ifloorplanObj.level[props.levelNowId].landscape_plan_pos_x * screenWidth / 100,
            y: ifloorplanObj.level[props.levelNowId].landscape_plan_pos_y * screenHeight / 100,
        })
        planRef.current.updateSize({
            width: ifloorplanObj.level[props.levelNowId].landscape_plan_width + "%",
        });
    }, [props.levelNowId]);

    const buttonTabLevel = (e) => {
        e.preventDefault();
        setActiveButtonTabLevel(!activeButtonTabLevel);
    }

    const tabsInit = () => {
        let tabs_ready = [];
        let media_tabs = [];
        let tabs_level = [];

        ifloorplanObj.level.length > 1 && ifloorplanObj.level.map((value, index) => {
            if (index == props.levelNowId) {
                tabs_ready.push(<div className="tab active_tab" key={index}>{value.tabLabel}</div>)
            } else {
                tabs_ready.push(<div className="tab" onClick={() => {
                    props.changeImageKey(0); //reset image key
                    if (ifloorplanObj.level[index].images.length == 0) {
                        props.nextStep("upload images", "exist images");
                    }
                    props.changeLevel(index);
                }} key={index}>{value.tabLabel}</div>)
            }
        });
        ifloorplanObj.media.map((value, index) => {
            media_tabs.push(<div className="tab" key={index}>{value.label}</div>)
        })
        tabs_ready.length > 1 && tabs_level.push(<div style={{ display: "block" }}>
            <div className="tab"
                onClick={(e) => buttonTabLevel((e))}>
                Level
            </div>
            <div className="tab_level" style={{ display: activeButtonTabLevel ? "block" : "none" }}>
                {tabs_ready}
            </div>
        </div>);
        setMediaTabs(media_tabs);
        setTabs(tabs_level);
    }

    useEffect(() => {
        tabsInit();
    }, [activeButtonTabLevel]);

    useEffect(() => {
        const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        for (let i = 0; i < newState.level.length; i++) {
            for (let j = 0; j < newState.level[i].images.length; j++) {
                newState.level[i].images[j].mobile_cam_width = markerScale;
            }
        }
        newState.level[props.levelNowId].custom_landscape = true;
        newState.mobile_marker_width = markerScale;
        props.ifloorplanStateAdd(newState);
    }, [markerScale]);

    return (
        <div className="landscape-scale-layout workplace">
            <div className="scales-panel">
                <div>
                    <div className="scale-wrapper">
                        <h3>Scale floor plans</h3>
                        <input type="range"
                            step="1"
                            className="scale-floor"
                            min="10"
                            max="90"
                            onChange={handleScale}
                            value={planLevel.img_width} />
                    </div>
                    <div className="scale-wrapper">
                        <h3 id='test'>Scale markers</h3>
                        <input type="range"
                            id='markersSize'
                            step="0.2"
                            className="scale-image"
                            min="2"
                            max="10"
                            value={markerScale}
                            onChange={(event => setMarkerScale(event.target.value))} />
                    </div>
                    <button onClick={() => props.nextStep("cams position", '_')}>
                        Done
                    </button>
                </div>
            </div>
            <div className='dnd-wrapper' style={{ width: width, height: height }}>
                <div className="tabs">
                    {tabs}{mediaTabs}
                </div>
                <Rnd
                    onDrag={dragHandleImage}
                    onDragStop={(e) => { e.preventDefault() }}
                    onDragStart={(e) => { e.preventDefault() }}
                    style={{
                        position: "absolute",
                    }}
                    enableResizing={false}
                    default={{
                        x: screenWidth * ifloorplanObj.level[props.levelNowId].landscape_plan_pos_x / 100,
                        y: screenHeight * ifloorplanObj.level[props.levelNowId].landscape_plan_pos_y / 100,
                        width: `${planLevel.img_width}%`,
                    }}
                    ref={planRef}>
                    <div className='floor-plan'>
                        {cams}
                        {doneMarkers}
                        {videoMarker}
                        <img className='floor-plan'
                            src={planLevel.img}
                            style={{ width: '100%' }} />

                    </div>
                </Rnd>

            </div>
        </div>
    )
}

const putState = (state) => {
    return {
        step: state.step,
        prev_step: state.prev_step,
        LibraryImage: state.LibraryImage,
        LibraryPlans: state.LibraryPlans,
        ifloorplanNowState: state.ifloorplanNowState,
        levelNowId: state.levelNowId,
        scale: state.scale,
        plans: state.plans
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        dropFiles: (files, title) => dispatch(dropFiles(files, title)),
        initScale: (bool) => dispatch(initScale(bool)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        changeLevel: (level) => dispatch(changeLevel(level)),
        changeImageKey: (key) => dispatch(changeImageKey(key)),
    }
}
export default connect(putState, putActions)(landscapeScaleLayout);